export default __webpack_public_path__ + "static/media/D2.4eada5a4.png";